<aside id="left_panel" class="nano affix sidebar_left_position" ng-class="tab == 0 ? 'show-mobile-sidebar' : 'hide-mobile-sidebar'">
    <div class="sidebar-head" id="eLeftPanel">
        <div class="sidebar-header p10" style="display:block;height: 30px;">
            <strong>Order(s)</strong>
            <div class="pull-right">
                <a href="#" ng-if="selectedRouteOrder.length" class="ml10" ng-click="assignMultiOrder()" style="color:#fff">
                    Assign {{ selectedRouteOrder.length }} Order(s)
                </a>
            </div>
        </div>

        <div class="sidebar-header p10" style="display:block">
            <input type="text" ng-model="searchOrderTerm" placeholder="Search Order(s)" class="form-control">
        </div>

        <ul class="sidebar-menu-tab mn pn">
            <li ng-class="statuses.work == 0 ? 'active' : '' " ng-click="setStatus(0,'work')" >
                <a href="#">
                    <h5 class="mbn mtn">{{ getSidebarOrders(0).length }}</h5>
                    <small>Unassigned</small>
                </a>
            </li>
            <li ng-class="statuses.work == 1 ? 'active' : '' " ng-click="setStatus(1,'work')">
                <a href="#">
                    <h5 class="mbn mtn">{{ getSidebarOrders(1).length }}</h5>
                    <small>Assigned</small>
                </a>
            </li>
            <li ng-class="statuses.work == 2 ? 'active' : '' " ng-click="setStatus(2,'work')">
                <a href="#">
                    <h5 class="mbn mtn">{{ getSidebarOrders(2).length }}</h5>
                    <small>Completed</small>
                </a>
            </li>
        </ul>
    </div>
    <div class="sidebar-block">
        <div class="list-sidebar pn" 
            ng-class="order.id == selectedOrderId ? 'selected-work' : ''"
            ng-repeat="order in getSidebarOrders(statuses.work, searchOrderTerm)" 
            ng-click="clickWork(order)"
            style="border: 2px solid #eee" 
            ng-style="{'border-color': order.status ? order.status.color : 'transparent' }"
            id="order-list-{{order.id}}">
         
            <div class="row p10 mbn pbn">
                <div class="col-md-2">
                    <label class="block option option-primary mn">
                        <input type="checkbox" ng-click="addSelectedOrderForOptimization(order.id)" ng-checked="selectedRouteOrder.indexOf(order.id) > -1 || master" id="checkboxDefault-{{order.id}}">
                        <span class="checkbox mn"></span>
                    </label>
                </div>
                <div class="col-md-6">
                    <strong class="order-list-time">
                        {{ order.location.name }}
                    </strong>
                    <p class="order-list-address mt5" ng-if="order.worker">
                        {{ order.worker.full_name }}
                    </p>
                    <p style="font-weight:bold; font-size: 12px; color:#f1703f" class="order-list-address mt5" ng-if="order.estimated_delivery">
                        ETA {{ order.estimated_delivery | amDateFormat:'hh:mm A' }}
                    </p>

                    <p class="order-list-address mt5" ng-if="!order.worker">
                        Not Assigned
                    </p>

                    <p class="order-list-address mt5" ng-if="order.package_type === 'large'">
                        LARGE
                    </p>
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center">
                    <div class="logo mb5" ng-if="order.customer.logo">
                        <img 
                            ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ order.customer.logo }}" 
                            class="img-responsive text-center img-circle" 
                            width="24px" 
                            height="24px" 
                            ng-if="order.customer.logo"
                            style="width:24px; height:24px;" 
                            class="img-responsive">
                    </div>
                    <div class="remaining-time" ng-style="{'background': '#eee' }">
                        <h5>{{ humanizeDurationMin(order.scheduled_time, 0) }}</h5> 
                    </div>
                </div>
            </div>
            <div class="pl10 pr10 pb5">
                <p class="order-list-worker" ng-if="order.worker_id != 0 && data.order_settings.worker_name" style="font-weight: 600;">
                    <i class="fa fa-user"></i> 
                    {{ order.worker.user.full_name }}
                    <a href="#" 
                        class="btn btn-default btn-xs pull-right" 
                        style="background: #F3F7FA;color:#5f6c74;font-weight:400"
                        ng-if="data.remaining_time && order.status.value != 'complete' " 
                        ng-click="getRemainingTime(order.id)">Kalan Süre</a>
                </p>
                <p class="order-list-worker" ng-if="order.worker_id == 0 && data.order_settings.worker_name" class="text-danger">
                    <i class="fa fa-user"></i> Atama yapılmamıştır.
                </p>

            </div>
            <!-- <hr class="mn" ng-if="order.dist">
            <div class="p10" ng-if="order.dist">
                <span ng-if="!order.dist">
                    Kalan süre hesaplanıyor...
                </span>
                <span ng-if="order.dist" class="text-warning">
                    Kalan Mesafe : {{ order.dist.distance }},
                    Kalan Süre : {{ order.dist.time }}
                </span>
            </div> -->
        </div>

        <!-- <div class="filter-bottom list-sidebar text-center pl20 pr20" ng-if="paginate.last_page != 1 && paginate.last_page != 0">
            <span style="color: #000 !important;">
                Sayfa : {{ paginate.current_page }} / {{ paginate.last_page }}, Toplam Kayıt : {{ paginate.total }}
            </span>
            <ul class="pagination pn mtn">
                <li ng-disabled="paginate.current_page != 1"><a href="javascript:void(0)" ng-click="getPage(1)">&laquo;</a></li>
                <li ng-disabled="paginate.current_page != 1"><a href="javascript:void(0)" ng-click="getPage(paginate.current_page-1)">&lsaquo; Geri</a></li>
                <li ng-disabled="paginate.current_page != paginate.last_page"><a href="javascript:void(0)" ng-click="getPage(paginate.current_page+1)">İleri &rsaquo;</a></li>
                <li ng-disabled="paginate.current_page != paginate.last_page"><a href="javascript:void(0)" ng-click="getPage(paginate.last_page)">&raquo;</a></li>
            </ul>
        </div> -->

        <!--<div class="new-work-today" ng-if="getWorkStatus('assign') == 0 && data.orders == 0">
            <h1>KargoBulunamdı!</h1>
            Hemen iş oluştur.
        </div>-->

    </div>
</aside>
<div ng-include="'modules/company/dashboard/partials/filter.html'" ng-show="filterPanel" 
    style="left:260px;border-left: 1px solid #ddd;">></div>
<!--
<div id="offsidebar-btn"
     ng-click="sidebar('left')" 
     class="sidebar_left_toggle hidden-sm hidden-md"
     ng-style="filterPanel && {'left':'520px'}">
     <i class="fa fa-arrow-left"></i>
</div>
-->